import { memo } from "react";

import { FormItem, FormLabel } from "@/components/ui/form/_base/form";
import { FormInputLabelWrapper } from "@/components/ui/form/_base/label/form-wrapper";
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/input/select";

type Children = {
	key: string;
	value: string;
};

export type SelectWithOptgroupOption = {
	label: string;
	children: Array<Children>;
};

type SelectWithOptgroupProps = {
	value: unknown;
	placeholder?: string;
	options: Array<SelectWithOptgroupOption>;
	onChangeCallback: (value: string) => void;

	label?: string;
};

export const SelectWithOptgroup = memo(
	({ value, placeholder, options, onChangeCallback, label }: SelectWithOptgroupProps) => {
		return (
			<FormInputLabelWrapper>
				{label && (
					<FormItem>
						<FormLabel>{label}</FormLabel>
					</FormItem>
				)}

				<div className="relative">
					<Select onValueChange={onChangeCallback} value={String(value)}>
						<div className="w-full">
							<SelectTrigger>
								<SelectValue placeholder={placeholder} />
							</SelectTrigger>
						</div>
						<SelectContent>
							{options.map((item, index) => {
								return (
									<SelectGroup key={item.label + index}>
										<SelectLabel>{item.label}</SelectLabel>
										<div className="p-2">
											{item.children.map((child, index) => {
												return (
													<SelectItem value={child.value} key={child.key + index}>
														{String(child.key)}
													</SelectItem>
												);
											})}
										</div>
									</SelectGroup>
								);
							})}
						</SelectContent>
					</Select>
				</div>
			</FormInputLabelWrapper>
		);
	},
);
